import React from 'react';

import { createStylesHook } from 'shared/hooks/createStylesHook';
import { IStep, StepProps, Step, StepDivider } from 'shared';

export interface StepperProps {
  activeStepId: IStep['id'];
  steps: IStep[];
  onStepClick?: StepProps['onStepClick'];
}

const useStyles = createStylesHook({
  stepperContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 222,
    minWidth: 222
  },
  contentParent: {
    display: 'flex'
  },
  contentContainer: {
    padding: '20px 0'
  }
});

export const Stepper: React.FunctionComponent<StepperProps> = ({ steps, activeStepId, onStepClick }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div className={classes.stepperContainer}>
      {steps.map((s, idx) => {
        return (
          <div key={`step-${idx}`}>
            <Step step={s} isActive={s.id === activeStepId} stepNumber={idx + 1} onStepClick={onStepClick} />
            {idx < steps.length - 1 ? !s.contentComponent ? <StepDivider completed={!!s.completed} /> : null : null}
            {s.subSteps
              ? s.subSteps.map((sub, idxSub) => {
                  return (
                    <div key={`step-${idx}-subStep-${idxSub}`}>
                      <Step step={sub} isActive={sub.id === activeStepId} onStepClick={onStepClick} isSubStep />
                      {idx < steps.length - 1 ? <StepDivider longer completed={!!sub.completed} /> : null}
                    </div>
                  );
                })
              : null}
            {!!s.contentComponent && (
              <div className={classes.contentParent}>
                <StepDivider completed={!!s.completed} />
                <div className={classes.contentContainer}>{s.contentComponent}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
